"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeObjectHistory = void 0;
const constants_1 = require("../../constants");
const constructs_1 = require("../../model/constructs");
const initializeObjectHistory = (objectHistory) => {
    if (objectHistory && !objectHistory?.recentStateHistory) {
        objectHistory.recentStateHistory = new constructs_1.HistoryStore(constructs_1.ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DEVICE_PERIOD));
    }
    if (objectHistory && !objectHistory?.dailyStateHistory) {
        objectHistory.dailyStateHistory = new constructs_1.HistoryStore(constructs_1.ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DAILY));
    }
    if (objectHistory && !objectHistory?.weeklyStateHistory) {
        objectHistory.weeklyStateHistory = new constructs_1.HistoryStore(constructs_1.ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.WEEKLY));
    }
    if (objectHistory && !objectHistory?.monthlyStateHistory) {
        objectHistory.monthlyStateHistory = new constructs_1.HistoryStore(constructs_1.ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.MONTHLY));
    }
    if (objectHistory && !objectHistory?.yearlyStateHistory) {
        objectHistory.yearlyStateHistory = new constructs_1.HistoryStore(constructs_1.ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.YEARLY));
    }
};
exports.initializeObjectHistory = initializeObjectHistory;
